import { connect } from 'react-redux';
import LaporanMapel from '../../views/Settings/LaporanMapel.view';
import { getClasses, getParamOptionsAcademics, getPrmLevels, getPeriodsOptions, getSchoolUnitsOptions, getParamPerwakilan } from '../../states/thunks/options.thunk';
import { listScheduleSubject, deleteScheduleSubject, listReportMapel, getListScheduleSubject, generateSchedule, getTotalJP, getNotesUnpostingSch, listReportMapelPerwakilan, listReportMapelPerunit } from '../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    result: state.result,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetClasses: payload => dispatch(getClasses(payload)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleListScheduleSubject: (payload, goback) => dispatch(listScheduleSubject(payload, goback)),
    handleListReportMapel: (payload, goback) => dispatch(listReportMapel(payload, goback)),
    handleListReportMapelPerwakilan: (payload, goback) => dispatch(listReportMapelPerwakilan(payload, goback)),
    handleListReportMapelPerunit: (payload, goback) => dispatch(listReportMapelPerunit(payload, goback)),

    handleDeleteScheduleSubject: (payload, goback) => dispatch(deleteScheduleSubject(payload, goback)),
    getPrmLevels: payload => dispatch(getPrmLevels(payload)),
    handleGetScheduleSubject: payload => dispatch(getListScheduleSubject(payload)),
    handleGenerateSchedule: payload => dispatch(generateSchedule(payload)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
    handleGetJp: payload => dispatch(getTotalJP(payload)),
    getNotesUnpostingSch: payload => dispatch(getNotesUnpostingSch(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getParamPerwakilan: payload => dispatch(getParamPerwakilan(payload)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(LaporanMapel);
